import {
  Component,
  Output,
  EventEmitter,
  OnDestroy,
  OnInit,
  AfterViewInit,
  ChangeDetectorRef,
  ViewChild,
  ElementRef,
  ViewChildren,
  QueryList,
  HostListener
} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {LayoutService} from '../services/layout.service';
import {Subscription} from 'rxjs';
import {ConfigService} from '../services/config.service';
import {FormControl, FormGroup, UntypedFormControl, Validators} from '@angular/forms';
import {LISTITEMS} from '../data/template-search';
import {Router} from '@angular/router';
import {AuthService} from '../auth/auth.service';
import {LocalStorageService} from '../storage/local-storage.service';
import {PULSERIGHT_ROUTES} from '../vertical-menu/vertical-pulseright-menu-routes.config';
import {ModalDismissReasons, NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {ToastrService} from 'ngx-toastr';
import {Patient} from '../../pages/full-pages/patients/list-patients/data/users-list.data';
import {QueryParamsServiceService} from '../query-params/query-params-service.service';
import {NgxSpinnerService} from 'ngx-spinner';
import {gql, MutationResult} from 'apollo-angular';
import {GraphQlService} from '../../services/graphQL/graph-ql.service';
import {map} from 'rxjs/operators';
import {phoneCode} from '../../pages/full-pages/phone_codes';
import {ApolloError, ApolloQueryResult} from '@apollo/client/core';
import {HttpErrorResponse} from '@angular/common/http';
import * as swalFunctions from '../data/sweet-alerts';

const moment = require('moment');


@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss']
})
export class NavbarComponent implements OnInit, AfterViewInit, OnDestroy {
  currentLang = 'en';
  selectedLanguageText = 'English';
  selectedLanguageFlag = './assets/img/flags/us.png';
  toggleClass = 'ft-maximize';
  placement = 'bottom-right';
  logoUrl = 'assets/img/logo.png';
  menuPosition = 'Side';
  isSmallScreen = false;
  protected innerWidth: any;
  searchOpenClass = '';
  checkType = 'Check-In';
  transparentBGClass = '';
  hideSidebar = true;
  userCheckStatus = false;
  checkedInData = null;
  getCheckedOrganization = '';
  public isCollapsed = true;
  layoutSub: Subscription;
  configSub: Subscription;
  appointmentList: any[] = [];
  selectedOrgGroup: any;
  timerLogout = null;


  @ViewChild('search') searchElement: ElementRef;
  @ViewChildren('searchResults') searchResults: QueryList<any>;

  @Output()
  toggleHideSidebar = new EventEmitter<Object>();

  @Output()
  seachTextEmpty = new EventEmitter<boolean>();

  listItems = [];
  control = new UntypedFormControl();

  userData: any = {
    auth: {
      data: {}
    },
    organizationGroupList: [],
    doctorList: [],
    SelectedOrg: '',
    SelectedOrgGrp: '',
    patientList: [],
    StaffList: [],
    serviceList: [],
    dashboard: {},
    appointmentList: [],
    managerDashboard: {},
    timeOffList: [],
    overTime: [],
  };

  public organizationList: any = [];
  checkInBtnShow = false;
  pharmacyList = [];
  displayCheckIn = false;

  public config: any = {};
  disabled = false;
  today = new Date();
  file = null;
  closeResult = '';
  user: Patient;

  // Update of Password..
  updateForm = new FormGroup({
    password: new FormControl('', [Validators.required,
      Validators.pattern('^(?=.*\\d)(?=.*[a-zA-Z])(?=.*[!@#$%^&*(),.?":{}|<>])[a-zA-Z\\d!@#$%^&*(),.?":{}|<>]{8,}$')]
    ),
    confrimPassword: new FormControl('', [Validators.required,
      Validators.pattern('^(?=.*\\d)(?=.*[a-zA-Z])(?=.*[!@#$%^&*(),.?":{}|<>])[a-zA-Z\\d!@#$%^&*(),.?":{}|<>]{8,}$')
    ])
  });
  OnformSubmitted = false;
  defaultSelectedOrg = '';

  editForm = new FormGroup({
    name: new FormControl('', [Validators.required]),
    email: new FormControl('', [Validators.required, Validators.email]),
    gender: new FormControl('', [Validators.required]),
    number: new FormControl('', [Validators.required, Validators.pattern('[0-9]{10}|[0-9]{9}')]),
  })
  orgGrpList = [];
  organizationGrp: any;
  profileImage = 'assets/img/defaultProfile.jpg';
  toggleEye = {
    newPassword: false,
    confirmPassword: false
  }
  countryCode = '';
  submitted = false;
  swal = swalFunctions;
  islogOut = false;
  bills = [];

  constructor(public translate: TranslateService,
              private layoutService: LayoutService,
              private router: Router,
              private spinner: NgxSpinnerService,
              private modalService: NgbModal,
              private configService: ConfigService,
              private cdr: ChangeDetectorRef,
              private auth: AuthService,
              private toastr: ToastrService, private queryParams: QueryParamsServiceService,
              private graphql: GraphQlService,
              private storage: LocalStorageService) {

    const browserLang: string = translate.getBrowserLang();
    this.translate.use(browserLang.match(/en|es|kn|ta|te|pt|de/) ? browserLang : 'en');
    this.config = this.configService.templateConf;
    this.innerWidth = window.innerWidth;
    this.layoutSub = layoutService.toggleSidebar$.subscribe(
      isShow => {
        this.hideSidebar = !isShow;
      });
  }

  async ngOnInit() {
    // ensure a per-login session token exists
    if (!sessionStorage.getItem('launch_session_token')) {
      sessionStorage.setItem('launch_session_token', String(Date.now())); // or generate UUID
    }

    await this.storage.getData('pulse-right').then(res => {
      if (res != null || res) {
        this.userData = res;
      }
    });
    // Watch storage for changes
    this.storage.watchStorage().subscribe(res => {
      if (res != null || res) {
        this.userData = res;
      }
    });

    if (this.userData.auth.data.role === 'Super Admin') {
      this.loadOrgGrps();
    }

    if (!window.location.pathname.includes('/booking')) {
      this.organizationGrp = JSON.parse(localStorage.getItem('organizationGroup')).data;
      this.fetchOrganization();
      if (this.userData.auth.data.userType === 'Manager') {
        if (this.organizationGrp.autoLogout.manager !== 'Never') {
          this.auth.INACTIVITY_PERIOD = Number(this.organizationGrp.autoLogout.manager) * 60 * 1000;
        } else {
          this.auth.INACTIVITY_PERIOD = 24 * 60 * 60 * 1000;
        }
      }
      if (this.userData.auth.data.userType === 'Staff') {
        if (this.organizationGrp.autoLogout.staff !== 'Never') {
          this.auth.INACTIVITY_PERIOD = Number(this.organizationGrp.autoLogout.staff) * 60 * 1000;
        } else {
          this.auth.INACTIVITY_PERIOD = 24 * 60 * 60 * 1000;
        }
      }
      if (this.userData.auth.data.role === 'Super Admin') {
        this.auth.INACTIVITY_PERIOD = 24 * 60 * 60 * 1000;
      }

      this.countryCode = JSON.parse(localStorage.getItem('organizationGroup')).data.contactPhone.substring(0, 3);
      if (this.userData.auth.data.userType === 'Pharmacy Admin') {
        this.fetchUser_details();
        this.organizationList = this.userData.auth.data.organization;
        return;
      }
      if (this.userData.auth.data.role !== 'Super Admin') {
        this.organizationList = this.userData.auth.data.organization;
        if (this.userData.auth.data.userType === 'Doctor') {
          // DOCTOR LOGIN
          const DOCTOR_QUERY = gql`query ($userId: ID!) {
            getUserProfile(userId: $userId) {
              ... on DoctorProfile {
                _id
                name
                number
                gender
                dateOfBirth
                email
                avatar
                autoLogOutTime
                organization {
                  organizationId {
                    _id
                    name
                    logo
                  }
                }
                about
                userType
              }
            }
          }`;
          this.graphql.executeQuery(this.userData, DOCTOR_QUERY, {userId: this.userData.auth.data._id}).subscribe({
            next: (responseDoctor: ApolloQueryResult<any> | any) => {
              const {getUserProfile} = responseDoctor.data;
              this.user = getUserProfile;
              if (this.user.autoLogOutTime && this.user.autoLogOutTime !== 'Never' && this.user.autoLogOutTime !== '') {
                this.auth.INACTIVITY_PERIOD = Number(this.user.autoLogOutTime) * 60 * 1000;
              }
            }, error: (error: ApolloError | HttpErrorResponse | any) => {
            }
          })
          return;
        }
        // STAFF MANAGER LOGIN
        if (['Manager', 'Staff'].includes(this.userData.auth.data.userType)) {
          this.organizationList = this.userData.auth.data.organization;
          if (this.userData.auth.data.userType === 'Staff') {
            this.loadMyAttendence();
          }
          this.defaultSelectedOrg = localStorage.getItem('orgGroupId');
        } else {
          this.defaultSelectedOrg = localStorage.getItem('orgGroupId');
          this.organizationList = this.userData.auth.data.organization;
        }
      } else {
        await this.fetchSpecificOrgGroup();
        await this.fetchAllOrgGroups();
      }
      this.fetchUser_details();
      if (!window.location.pathname.includes('/booking')) {
        this.auth.orgGrpSubject.subscribe(data => {
          if (data === 'loadGroups') {
            this.loadOrgGrps();
          }
        });
      }
    }
  }


  fetchOrganization() {
    const QUERY = gql`
      query ($orgId: ID!) {
        getOrganizationById(orgId: $orgId) {
          _id
          name
          number
          email
          address
          url
          logo
          status
          primaryColor
          secondaryColor
          patientSync
          modulesEnabled
          latestBill{
            _id
            dueDate_to_pay
            billStatus
            invoice_no
          }
          modulesCost{
            moduleId
            cost
            name
            childId
          }
        }
      } `;
    this.graphql.fetch_organization_Id(QUERY, this.userData, this.userData.SelectedOrg).then(async (response: any) => {
      const orgDetails = response.data.getOrganizationById;
      const root = document.documentElement;
      root.style.setProperty('--primary-color-organization', orgDetails.primaryColor);
      root.style.setProperty('--secondary-color-organization', orgDetails.secondaryColor);
      if (!orgDetails.status && !['Doctor', 'Admin'].includes(this.userData?.auth?.data?.userType)) {
        this.auth.logout();
        this.spinner.hide();
        await this.router.navigate(['/login-admin']);
        return;
      }
      const moduleNames = [];
      orgDetails.modulesCost.map(mod => {
        if (orgDetails.modulesEnabled.includes(mod.moduleId)) {
          moduleNames.push(mod.name.trim());
        }
      });
      localStorage.setItem('moduleNames', JSON.stringify(moduleNames));
      await this.graphql.setMenusByAllowedList(this.userData.auth.data.userType, moduleNames);
      this.userData = JSON.parse(localStorage.getItem('pulse-right'));
      this.userData = {...this.userData, ['moduleNames']: this.userData.auth.data.role === 'Super Admin' ? [] : moduleNames};
      await this.storage.saveData('pulse-right', JSON.stringify(this.userData));
      this.auth.callOrganization.next(orgDetails);

      if (['Staff', 'Manager', 'Doctor', 'Pharmacy Admin'].includes(this.userData?.auth?.data?.userType)) {
        await this.getBillsOfOrganization(orgDetails);
        if (this.islogOut) {
          await this.spinner.hide();
          return;
        }
      }

      if (this.userData.auth.data.role === 'Super Admin') {
        this.auth.MenuOptions.consultation = true;
        this.auth.MenuOptions.aptEnabled = true;
        this.auth.MenuOptions.pharmacybill = true;
        this.auth.MenuOptions.prescrption = true;
        this.auth.MenuOptions.walkInbtn = true;
        this.auth.MenuOptions.enableQuue = true;
      } else {
        orgDetails.modulesCost.map((module) => {
          if (module.name === 'Leave Tracker') {
            this.checkInBtnShow = !!orgDetails.modulesEnabled.includes(module.moduleId);
          }
          if (module.name === 'Prescription List') {
            this.auth.MenuOptions.prescrption = !!orgDetails.modulesEnabled.includes(module.moduleId);
          }
          if (module.name === 'My Queue List') {
            this.auth.MenuOptions.enableQuue = !!orgDetails.modulesEnabled.includes(module.moduleId);
          }
          if (module.name === 'Appointments') {
            this.auth.MenuOptions.walkInbtn = !!orgDetails.modulesEnabled.includes(module.moduleId);
          }
          if (module.name === 'Consultation Bill') {
            this.auth.MenuOptions.consultation = this.userData.auth.data.role === 'Super Admin' ? true : !!orgDetails.modulesEnabled.includes(module.moduleId);
          }
          if (module.name === 'Pharmacies') {
            this.auth.MenuOptions.pharmacybill = this.userData.auth.data.role === 'Super Admin' ? true : !!orgDetails.modulesEnabled.includes(module.moduleId);
          }
        });
      }
      await this.spinner.hide();
    });
  }


  async getBillsOfOrganization(organization) {
    this.spinner.hide();
    const {latestBill = []} = organization;

    if (latestBill.length === 0) {
      this.auth.setOraganizationBill(null);
      return;
    }
    const formattedBills = latestBill.map((bill: any) => {
      const today = moment(new Date()).format('YYYY-MM-DD');
      const diff = moment(bill.dueDate_to_pay.split('T')[0]).diff(today, 'days');
      return {
        ...bill,
        ['isBillExpired']: diff < 0 && bill.billStatus !== 'paid',
        ['isWithInTwtyOneDays']: diff <= 21 && bill.billStatus !== 'paid',
        ['diff']: diff
      };
    });

    const checkIfAnyOneIsExpired = formattedBills.some((bill: any) => bill.isBillExpired);
    const organizationIds = this.organizationList.map((ele: { _id: string }) => ele._id);
    if (checkIfAnyOneIsExpired) {
      this.auth.setOraganizationBill(null);
      return;
    }
    if (!checkIfAnyOneIsExpired) {
      this.auth.setOraganizationBill(formattedBills);
    }
  }


  async fetchAllOrgGroups() {
    const ORGS_GROUPS = gql`
      query ($page: Int, $pageSize: Int) {
        getOrganizationGroups(page: $page, pageSize: $pageSize) {
          currentPage
          totalPages
          totalResults
          results {
            _id
            Name
            contactPhone
            contactEmail
            url
            organization {
              _id
              name
            }
          }
        }
      }
    `;
    const input = {
      page: 1, pageSize: 200
    }
    this.graphql.fetchAllOrganizationGroups(this.userData, ORGS_GROUPS, input).then((response: any) => {
      const result = response.data.getOrganizationGroups;
      this.orgGrpList = result.results;
    });

  }

  showSpinner() {
    this.spinner.show(undefined,
      {
        type: 'ball-triangle-path',
        size: 'medium',
        bdColor: 'rgba(0, 0, 0, 0.8)',
        color: '#fff',
        fullScreen: true
      });
  }

  async fetchSpecificOrgGroup() {
    const ORG_GROUP = gql`query ($organizationGroupId:ID!) {
      getSpecificOrganizationGroup(organizationGroupId: $organizationGroupId) {
        _id
        Name
        contactEmail
        countryCode
        contactPhone
        primaryColor
        secondaryColor
        url
        organization {
          _id
          name
          number
          primaryColor
          secondaryColor
          modulesCost {
            moduleId
            cost
          }
          logo
          moduleAddedOrRemovedInBetween {
            moduleId
            moduleAddedOrRemovedDate
            Added
          }
        }
      }
    }`;

    this.graphql.fetchOrgGrpById(this.userData, ORG_GROUP, this.userData.SelectedOrgGrp).then((response: any) => {
      const result = response.data.getSpecificOrganizationGroup;
      this.countryCode = phoneCode[result.countryCode];
      this.organizationList = result.organization;
      localStorage.setItem('orgGroupId', result._id);
      const org = this.organizationList.find((org) => org._id === this.userData.SelectedOrg);
      const root = document.documentElement;
      root.style.setProperty('--primary-color-organization', org.primaryColor);
      root.style.setProperty('--secondary-color-organization', org.secondaryColor);
      this.defaultSelectedOrg = localStorage.getItem('orgGroupId');
    });
  }


  fetchUser_details() {
    const QUERY = gql`query ($userId: ID!) {
      getUserProfile(userId: $userId) {
        ... on UserProfile {
          _id
          name
          number
          email
          gender
          avatar
          dateOfBirth
        }
        ... on DoctorProfile {
          _id
          name
          number
          gender
          dateOfBirth
          email
          autoLogOutTime
          avatar
          organization {
            organizationId {
              _id
              name
              logo
            }
          }
          about
        }
      }
    }`;

    this.graphql.executeQuery(this.userData, QUERY, {userId: this.userData.auth.data._id}).subscribe({
      next: (response: any) => {
        const {getUserProfile} = response.data;
        this.user = getUserProfile;
        this.editForm.controls['name'].setValue(this.user.name)
        this.editForm.controls['email'].setValue(this.user.email)
        this.editForm.controls['number'].setValue(this.user.number.split(this.countryCode)[1])
        this.editForm.controls['gender'].setValue(this.user.gender);
        this.profileImage = this.user.avatar ? this.user.avatar : 'assets/img/defaultProfile.jpg';
        if (this.userData.auth.data.userType === 'Manager') {
          if (this.organizationGrp.autoLogout.manager !== 'Never') {
            this.auth.INACTIVITY_PERIOD = Number(this.organizationGrp.autoLogout.manager) * 60 * 1000;
          } else {
            this.auth.INACTIVITY_PERIOD = 24 * 60 * 60 * 1000;
          }
        }
        if (this.userData.auth.data.userType === 'Staff') {
          if (this.organizationGrp.autoLogout.staff !== 'Never') {
            this.auth.INACTIVITY_PERIOD = Number(this.organizationGrp.autoLogout.staff) * 60 * 1000;
          } else {
            this.auth.INACTIVITY_PERIOD = 24 * 60 * 60 * 1000;
          }
        }
        if (this.userData.auth.data.role === 'Super Admin') {
          this.auth.INACTIVITY_PERIOD = 24 * 60 * 60 * 1000;
        }
        this.spinner.hide();
      }, error: (error: any) => {
        this.spinner.hide();
      }
    });
  }

  fetchOrganizationId() {
    const QUERY = gql`
      query ($orgId: ID!) {
        getOrganizationById(orgId: $orgId) {
          _id
          name
          website
          address
          createdDate
          status
          logo
          primaryColor
          secondaryColor
        }
      } `;

    this.graphql.fetch_organization_Id(QUERY, this.userData, this.userData.SelectedOrg).then((response: any) => {
      const orgDetails = response.data.getOrganizationById;
      const root = document.documentElement;
      root.style.setProperty('--primary-color-organization', orgDetails.primaryColor);
      root.style.setProperty('--secondary-color-organization', orgDetails.secondaryColor);
    })
  }

  // image data to base64 conversion
  fileToBase64(file: File): Promise<string> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      // Define onload event handler
      reader.onload = () => {
        const result = reader.result;
        if (typeof result === 'string') {
          resolve(result);
        } else {
          reject(new Error('Failed to convert file to base64'));
        }
      };

      // Define onerror event handler
      reader.onerror = (error) => {
        reject(error);
      };

      // Read file as data URL
      reader.readAsDataURL(file);
    });
  }

  // upload pharmcy logo and convert it to base64
  async upload(event: any) {
    this.file = event.target.files[0];
    if (!this.file) {
      return;
    }
    try {
      const base64Logo = await this.compressImage(this.file, 500, 0.7);
      this.profileImage = base64Logo;
    } catch (error) {
      this.toastr.error('Upload lesser size Image', 'Message');
      console.error('Image compression failed', error);
    }
  }

  compressImage(file: File, maxWidth = 500, quality = 0.7): Promise<string> {
    return new Promise((resolve, reject) => {
      const img = new Image();
      const reader = new FileReader();
      reader.onload = (e: any) => img.src = e.target.result;
      reader.onerror = reject;
      img.onerror = reject;
      img.onload = () => {
        const canvas = document.createElement('canvas');
        const scale = maxWidth / img.width;
        canvas.width = maxWidth;
        canvas.height = img.height * scale;
        const ctx = canvas.getContext('2d')!;
        ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
        try {
          const webpDataUrl = canvas.toDataURL('image/webp', quality);
          resolve(webpDataUrl);
        } catch (err) {
          const pngDataUrl = canvas.toDataURL('image/png');
          resolve(pngDataUrl);
        }
      };
      reader.readAsDataURL(file);
    });
  }


  async uploadImage(type = false) {
    if (this.file) {
      this.showSpinner();
      const QUERY = gql`
        mutation UploadAvatar($userId: ID!, $base64Image: String!) {
          uploadAvatar(userId: $userId, base64Image: $base64Image) {
            message
            url
          }
        }
      `;

      const input = {
        userId: this.userData.auth.data._id,
        base64Image: this.profileImage
      };

      this.graphql.executeMutateQuery(this.userData, QUERY, input).subscribe({
        next: (response: MutationResult | any) => {
          this.toastr.clear();
          this.spinner.hide();
          this.toastr.success('Image uploaded successfully', 'Message', {positionClass: 'toast-top-center'});
          if (type) {
            this.fetchUser_details();
          }
          this.file = null;
        }, error: (error: ApolloError | any | HttpErrorResponse) => {
          this.toastr.clear();
          this.spinner.hide();
          this.toastr.error('Image upload failed', 'Message', {positionClass: 'toast-top-center'});
        }
      })
    }

  }


  loadOrgGrps() {
    const ORGS_GROUPS = gql`
      query ($page: Int,$pageSize: Int) {
        getOrganizationGroups(page: $page, pageSize: $pageSize) {
          currentPage
          totalPages
          totalResults
          results {
            _id
            Name
            contactPhone
            contactEmail
            url
            organization {
              _id
              name
            }
          }
        }
      }
    `;
    const input = {
      page: 1, pageSize: 200
    }
    this.graphql.executeQuery(this.userData, ORGS_GROUPS, input).subscribe({
      next: async (response: ApolloQueryResult<any> | any) => {
        const {getOrganizationGroups} = response.data;
        this.orgGrpList = getOrganizationGroups.results;
        this.userData.organizationGroupList = getOrganizationGroups.results;
        await this.storage.saveData('pulse-right', JSON.stringify(this.userData));
        this.defaultSelectedOrg = localStorage.getItem('orgGroupId');
        this.spinner.hide();
      }, error: (error: ApolloError | any | HttpErrorResponse) => {
        this.spinner.hide();
      }
    });
  }

  loadMyAttendence() {
    const QUERY = gql`
      query GetUserAttendance($filter: GetUserAttendanceInput!) {
        getUserAttendance(filter: $filter) {
          userId
          userName
          organizationId
          checkedIn
          attendance {
            date
            checkIns
            checkOuts
          }
        }
      }`;

    const bodyInput = {
      'filter': {
        'userId': this.userData.auth.data._id,
        'organizationId': this.userData.SelectedOrg,
        'page': 1,
        'pageSize': 10
      }
    }

    this.graphql.executeQuery(this.userData, QUERY, bodyInput).subscribe({
      next: (response: ApolloQueryResult<any> | any) => {
        const {getUserAttendance} = response.data;
        this.userCheckStatus = getUserAttendance.checkedIn;
        this.checkedInData = getUserAttendance;
        this.getCheckedOrganization = this.checkedInData.organizationId;
        if (this.userCheckStatus) {
          this.checkType = 'Check-Out';
        } else {
          this.checkType = 'Check-In';
        }
      }, error: (error: ApolloError | HttpErrorResponse | any) => {
        this.getCheckedOrganization = this.userData.SelectedOrg;
        this.checkedInData = null;
      }
    });
  }


  OnSubmit(modal) {
    this.OnformSubmitted = true;
    if (this.updateForm.invalid) {
      return;
    }
    if (this.updateForm.value.password !== this.updateForm.value.confrimPassword) {
      this.toastr.clear();
      this.toastr.error('Password is mismatch!', 'Message!', {
        positionClass: 'toast-top-center'
      });
      return;
    }

    let updateObj = {};
    if (this.updateForm.controls.password.dirty) {
      updateObj = {
        ...updateObj, ['password']: this.updateForm.value.password
      };
    }
    const USER_UPDATE_QUERY = gql`
      mutation UpdateUser($userId: ID!, $input: UpdateUserInput!) {
        updateUser(userId: $userId, input: $input) {
          message
          user {
            name
            email
            number
            gender
          }
        }
      }
    `;
    this.graphql.executeMutateQuery(this.userData, USER_UPDATE_QUERY, {userId: this.userData.auth.data._id, input: updateObj}).subscribe({
      next: (response: MutationResult | any) => {
        this.toastr.clear();
        this.toastr.success('Password changed successfully', 'Message!', {
          positionClass: 'toast-top-center'
        });
        modal.dismiss('Cross-Click');
        this.clear();
        this.auth.logout();
        this.router.navigate(['/login-admin']);
      }, error: (error: ApolloError | any | HttpErrorResponse) => {
        const {errors} = error.error;
        modal.dismiss('Cross-Click');
        const message = errors.map(er => er.message).join(' ');
        this.toastr.clear();
        this.toastr.error(message, 'Message!', {
          positionClass: 'toast-top-center'
        });
      }
    });
  }


  clear() {
    this.updateForm.reset();
    this.OnformSubmitted = false;
  }

  get lf() {
    return this.updateForm.controls;
  }


  ngAfterViewInit() {
    this.configSub = this.configService.templateConf$.subscribe((templateConf) => {
      if (templateConf) {
        this.config = templateConf;
      }
      this.loadLayout();
      this.cdr.markForCheck();

    })
  }

  async refreshData() {
    this.listItems = LISTITEMS;

    if (this.innerWidth < 1200) {
      this.isSmallScreen = true;
    } else {
      this.isSmallScreen = false;
    }
  }

  ngOnDestroy() {
    if (this.layoutSub) {
      this.layoutSub.unsubscribe();
    }
    if (this.configSub) {
      this.configSub.unsubscribe();
    }
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.innerWidth = event.target.innerWidth;
    if (this.innerWidth < 1200) {
      this.isSmallScreen = true;
    } else {
      this.isSmallScreen = false;
    }
  }

  loadLayout() {

    if (this.config.layout.menuPosition && this.config.layout.menuPosition.toString().trim() !== '') {
      this.menuPosition = this.config.layout.menuPosition;
    }

    if (this.config.layout.variant === 'Light') {
      this.logoUrl = 'assets/img/logo-dark.png';
    } else {
      this.logoUrl = 'assets/img/logo.png';
    }

    if (this.config.layout.variant === 'Transparent') {
      this.transparentBGClass = this.config.layout.sidebar.backgroundColor;
    } else {
      this.transparentBGClass = '';
    }

  }

  onSearchKey(event: any) {
    if (this.searchResults && this.searchResults.length > 0) {
      this.searchResults.first.host.nativeElement.classList.add('first-active-item');
    }

    if (event.target.value === '') {
      this.seachTextEmpty.emit(true);
    } else {
      this.seachTextEmpty.emit(false);
    }
  }

  removeActiveClass() {
    if (this.searchResults && this.searchResults.length > 0) {
      this.searchResults.first.host.nativeElement.classList.remove('first-active-item');
    }
  }

  onEscEvent() {
    this.control.setValue('');
    this.searchOpenClass = '';
    this.seachTextEmpty.emit(true);
  }

  onEnter() {
    if (this.searchResults && this.searchResults.length > 0) {
      const url = this.searchResults.first.url;
      if (url && url !== '') {
        this.control.setValue('');
        this.searchOpenClass = '';
        this.router.navigate([url]);
        this.seachTextEmpty.emit(true);
      }
    }
  }

  redirectTo(value) {
    this.router.navigate([value]);
    this.seachTextEmpty.emit(true);
  }


  ChangeLanguage(language: string) {
    this.translate.use(language);

    if (language === 'en') {
      this.selectedLanguageText = 'English';
      this.selectedLanguageFlag = './assets/img/flags/us.png';
    } else if (language === 'es') {
      this.selectedLanguageText = 'Spanish';
      this.selectedLanguageFlag = './assets/img/flags/es.png';
    } else if (language === 'pt') {
      this.selectedLanguageText = 'Portuguese';
      this.selectedLanguageFlag = './assets/img/flags/pt.png';
    } else if (language === 'de') {
      this.selectedLanguageText = 'German';
      this.selectedLanguageFlag = './assets/img/flags/de.png';
    }
  }

  ToggleClass() {
    if (this.toggleClass === 'ft-maximize') {
      this.toggleClass = 'ft-minimize';
    } else {
      this.toggleClass = 'ft-maximize';
    }
  }

  toggleSearchOpenClass(display) {
    this.control.setValue('');
    if (display) {
      this.searchOpenClass = 'open';
      setTimeout(() => {
        this.searchElement.nativeElement.focus();
      }, 0);
    } else {
      this.searchOpenClass = '';
    }
    this.seachTextEmpty.emit(true);


  }


  toggleNotificationSidebar() {
    this.layoutService.toggleNotificationSidebar(true);
  }

  toggleSidebar() {
    this.layoutService.toggleSidebarSmallScreen(this.hideSidebar);
  }

  logout() {
    this.auth.logout();
    if (localStorage.getItem('showOneTime') === 'oneTime' && this.userData.auth.data.role !== 'Super Admin') {
      localStorage.setItem('showOneTime', 'One_time_finished');
    }
    this.router.navigate(['/login-admin']);

    const body = document.body;
    [
      'menu-expanded','vertical-menu','menu-open','menu-hide','vertical-layout',
      'horizontal-layout','horizontal-menu','menu-expanded','nav-collapsed',
      'vertical-overlay-menu','overflow-hidden','menu-open','blank-page',
      'layout-dark','layout-transparent','menu-expanded'
    ].forEach(cls => body.classList.remove(cls));
    body.removeAttribute('data-menu');

    const overlay = document.querySelector('.sidenav-overlay');
    if (overlay && overlay.parentNode) { overlay.parentNode.removeChild(overlay); }
    
    const dragTarget = document.querySelector('.drag-target');
    if (dragTarget && dragTarget.parentNode) { dragTarget.parentNode.removeChild(dragTarget); }
    
    localStorage.removeItem('pulse-right');
    sessionStorage.removeItem('launch_session_token');
    history.pushState(null, '', location.href);
    window.onpopstate = () => {
      history.go(1);
    }
  }

  async OnChangeOrgGrp(event: any) {
    this.selectedOrgGroup = event.target.value;
    this.defaultSelectedOrg = event.target.value;
    this.queryParams.setParams({});
    localStorage.setItem('orgGroupId', event.target.value);
    this.organizationList = [];
    const QUERY = gql`
      query ($organizationGroupId: ID!) {
        getSpecificOrganizationGroup(organizationGroupId: $organizationGroupId) {
          _id
          Name
          countryCode
          primaryColor
          secondaryColor
          organization {
            _id
            name
            number
            primaryColor
            secondaryColor
            logo
          }
        }
      }`;
    const input = {
      organizationGroupId: event.target.value
    };
    this.graphql.executeQuery(this.userData, QUERY, input).subscribe({
      next: async (response: ApolloQueryResult<any> | any) => {
        const {getSpecificOrganizationGroup} = response.data;
        this.countryCode = phoneCode[getSpecificOrganizationGroup.countryCode];
        this.organizationList = getSpecificOrganizationGroup.organization;
        localStorage.setItem('organization', getSpecificOrganizationGroup.organization[0]._id);
        this.userData.SelectedOrgGrp = getSpecificOrganizationGroup._id;
        this.userData.SelectedOrg = getSpecificOrganizationGroup.organization[0]._id;
        await this.storage.saveData('pulse-right', JSON.stringify(this.userData));
        this.fetchOrganization();
        await this.spinner.hide();
      }, error: (error) => {
        this.spinner.hide();
      }
    });
  }

  async OnChangeOrg(event) {
    this.userData.SelectedOrg = event.target.value;
    await this.storage.saveData('pulse-right', JSON.stringify(this.userData));
    localStorage.setItem('organization', event.target.value);
    this.queryParams.setParams({});
    if (['Staff', 'Manager'].includes(this.userData.auth.data.userType)) {
      this.fetchOrganization();
      if (this.userData.auth.data.userType === 'Staff') {
        this.loadMyAttendence();
      }
      if (!window.location.pathname.includes('/dashboard')) {
        await this.router.navigate(['/dashboard']);
      }
    } else {
      this.fetchOrganization();
      this.auth.pharmacyRefresh.next('doctor');
      await this.router.navigate(['/doctor-queue-lists']);
    }
  }


  async OnChangeOrganization_Box(event) {
    localStorage.setItem('organization', event.target.value);
    this.queryParams.setParams({});
    this.userData.SelectedOrg = event.target.value;
    await this.storage.saveData('pulse-right', JSON.stringify(this.userData));
    this.auth.MenuOptions.isLoading = true;
    this.auth.MenuOptions.isLoading1 = true;
    this.fetchOrganization();
    await this.router.navigate(['/dashboard']);
    await this.spinner.hide();
  }


  async open(content, size) {
    this.toggleEye = {
      newPassword: false,
      confirmPassword: false
    }
    this.OnformSubmitted = false;
    this.file = null;
    this.updateForm.reset();
    if (this.userData) {
      this.profileImage = 'assets/img/defaultProfile.jpg';
      this.showSpinner();
      await this.fetchUser_details();
    }
    this.modalService.open(content, {size: size, backdrop: 'static'});
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  async autoRefresh() {
    this.storage.getData('pulse-right').then(res => {
      if (res != null || res) {
        this.userData = res;
      }
      ;
    });
    // Watch storage for changes
    this.storage.watchStorage().subscribe(res => {
      if (res != null || res) {
        this.userData = res;
      }
    });
    await this.router.navigate(['/dashboard'])
  }


  async EditProfileDetails(modal: any) {
    this.OnformSubmitted = true;
    if (this.editForm.invalid) {
      return;
    }
    let body = {};
    for (const key in this.editForm.controls) {
      if (key === 'number' && this.editForm.controls[key].dirty) {
        body = {...body, [key]: this.countryCode + this.editForm.controls[key].value};
      } else if (this.editForm.controls[key].dirty) {
        body = {...body, [key]: this.editForm.controls[key].value};
      }
    }

    if (this.file && Object.keys(body).length === 0) {
      await this.uploadImage(true);
      modal.dismiss('Cross-Click');
      return;
    }


    if (!this.file && Object.keys(body).length === 0) {
      modal.dismiss('Cross-Click');
      return;
    }

    const USER_UPDATE_QUERY = gql`
      mutation UpdateUser($userId: ID!, $input: UpdateUserInput!) {
        updateUser(userId: $userId, input: $input) {
          message
          user {
            name
            email
            number
            gender
          }
        }
      }
    `;
    this.graphql.executeMutateQuery(this.userData, USER_UPDATE_QUERY, {userId: this.user._id, input: body}).subscribe({
      next: async (response: MutationResult | any) => {
        this.toastr.clear();
        this.toastr.success('Profile Updated successfully', 'Message!', {
          positionClass: 'toast-top-center'
        });
        if (this.file) {
          await this.uploadImage(true);
        } else {
          this.fetchUser_details();
        }
        this.file = null;
      }, error: (error: ApolloError | HttpErrorResponse | any) => {
        const {errors} = error.error;
        this.toastr.clear();
        this.toastr.error(errors[0].message, 'Message', {
          positionClass: 'toast-top-center'
        });
      }
    });
    modal.dismiss('Cross-Click');
  }


  checkIn_out() {
    const QUERY = gql`
      mutation CheckInOut($input: CheckInOutInput!) {
        checkInOut(input: $input) {
          message
        }
      }`;
    const bodyInput = {
      'input': {
        'userId': this.userData.auth.data._id,
        'organizationId': this.organizationList[0]._id,
        'status': this.userCheckStatus ? 'checked-Out' : 'checked-In'
      }
    }

    this.graphql.executeMutateQuery(this.userData, QUERY, bodyInput).subscribe({
      next: (response: MutationResult | any) => {
        this.toastr.clear();
        const successMessage = this.userCheckStatus ? 'Checked-Out Successfully' : 'Checked-In Successfully';
        this.toastr.success(successMessage, 'Message!', {
          positionClass: 'toast-top-center'
        });
        this.loadMyAttendence();
      }, error: (error: ApolloError | HttpErrorResponse | any) => {
        const {errors} = error.error;
        this.toastr.clear();
        this.toastr.error(errors[0].message, 'Message', {
          positionClass: 'toast-top-center'
        });
      }
    });
  }

  async SwitchOrg(event) {
    this.userData.SelectedOrg = event.target.value;
    await this.storage.saveData('pulse-right', JSON.stringify(this.userData));
    localStorage.setItem('organization', event.target.value);
    this.fetchOrganization();
    this.auth.pharmacyRefresh.next('pharmacy');
  }

  openModal(content) {
    this.submitted = false;
    this.timerLogout = null;
    this.fetchUser_details();
    this.modalService.open(content, {size: 'md', backdrop: 'static'});
  }

  setAutoLogoutForUser(modal) {
    this.submitted = true;
    if (!this.timerLogout) {
      return;
    }
    let body = {'autoLogOutTime': String(this.timerLogout)};
    this.auth.resetTimer();
    this.showSpinner();


    const USER_UPDATE_QUERY = gql`
      mutation UpdateUser($userId: ID!, $input: UpdateUserInput!) {
        updateUser(userId: $userId, input: $input) {
          message
          user {
            name
            email
            number
            gender
          }
        }
      }
    `;

    this.graphql.executeMutateQuery(this.userData, USER_UPDATE_QUERY, {userId: this.user._id, input: body}).subscribe({
      next: (response: MutationResult | any) => {
        if (this.userData.auth.data.userType === 'Doctor') {
          if (this.user.autoLogOutTime !== 'Never') {
            this.auth.INACTIVITY_PERIOD = Number(this.timerLogout) * 60 * 1000;
          } else {
            this.auth.INACTIVITY_PERIOD = 24 * 60 * 60 * 1000;
          }
        }
        this.toastr.clear();
        this.toastr.success('Auto logout time updated successfully', 'Message', {
          positionClass: 'toast-top-center'
        });
        this.spinner.hide();
        modal.dismiss('Cross-Click');
      }, error: (error: ApolloError | any | HttpErrorResponse) => {

      }
    });
  }
}
